import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { PencilSimple, Trash } from "@phosphor-icons/react";

export default function CrudActions({ testidBase, onEdit, onDelete, canDelete = true, name = "record", linkedHint }) {
  return (
    <div className="flex items-center gap-1">
      <button
        data-testid={`edit-${testidBase}`}
        onClick={onEdit}
        title="Edit"
        className="h-8 w-8 rounded-md flex items-center justify-center text-slate-500 hover:bg-slate-100 hover:text-slate-900 transition-colors"
      >
        <PencilSimple size={16} />
      </button>
      {canDelete ? (
        <AlertDialog>
          <AlertDialogTrigger asChild>
            <button
              data-testid={`delete-${testidBase}`}
              title="Delete"
              className="h-8 w-8 rounded-md flex items-center justify-center text-slate-500 hover:bg-red-50 hover:text-red-600 transition-colors"
            >
              <Trash size={16} />
            </button>
          </AlertDialogTrigger>
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle>Delete {name}?</AlertDialogTitle>
              <AlertDialogDescription>This action cannot be undone.</AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel data-testid={`cancel-delete-${testidBase}`}>Cancel</AlertDialogCancel>
              <AlertDialogAction
                data-testid={`confirm-delete-${testidBase}`}
                onClick={onDelete}
                className="bg-red-600 hover:bg-red-700"
              >
                Delete
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      ) : (
        <span
          data-testid={`delete-locked-${testidBase}`}
          title={linkedHint || "Linked to other records — cannot delete"}
          className="h-8 w-8 rounded-md flex items-center justify-center text-slate-300 cursor-not-allowed"
        >
          <Trash size={16} />
        </span>
      )}
    </div>
  );
}
